export const COMPARE_MODE_SPECIES = 'species';
export const COMPARE_MODE_OWNED = 'owned';
export const COMPARE_LEVEL_MAX = 300;

export function normalizeCompareLevel(value, max = COMPARE_LEVEL_MAX) {
  const numeric = Number(value);
  const upper = Math.max(1, Number.isFinite(Number(max)) ? Math.floor(Number(max)) : COMPARE_LEVEL_MAX);
  if (!Number.isFinite(numeric)) return 1;
  return Math.max(1, Math.min(upper, Math.floor(numeric)));
}

export function compareEvolutionOptions(chain) {
  const forms = Array.isArray(chain) && chain.length ? chain : [];
  return forms.map((species, index) => ({
    species,
    index,
    requiredLevel: index === 0 ? 1 : forms.length === 2 ? 60 : index === 1 ? 40 : 70,
  }));
}

export function ownedCompareEntries(starter, collection) {
  const entries = [];
  if (starter?.name) entries.push({ key: 'starter', pokemon: starter, isStarter: true });
  for (const [index, pokemon] of (Array.isArray(collection) ? collection : []).entries()) {
    if (!pokemon?.name) continue;
    const key = pokemon.id == null ? `collection-index:${index}` : `collection:${pokemon.id}`;
    entries.push({ key, pokemon, isStarter: false });
  }
  return entries;
}

export function resolveOwnedCompareSelection(slot, pokemon, chainForSpecies = () => []) {
  if (slot?.mode !== COMPARE_MODE_OWNED || !pokemon?.name) return null;
  const rawChain = chainForSpecies(pokemon.name);
  const chain = Array.isArray(rawChain) && rawChain.length ? rawChain : [pokemon.name];
  const species = chain.includes(slot.evolution) ? slot.evolution : pokemon.name;
  const actualLevel = normalizeCompareLevel(pokemon.level, Number.MAX_SAFE_INTEGER);
  const maxLevel = Math.max(COMPARE_LEVEL_MAX, actualLevel);
  return {
    mode: COMPARE_MODE_OWNED,
    species,
    level: normalizeCompareLevel(slot.level == null ? actualLevel : slot.level, maxLevel),
    actualLevel,
    actualSpecies: pokemon.name,
    ivs: pokemon.ivs && typeof pokemon.ivs === 'object' ? { ...pokemon.ivs } : undefined,
    rarity: pokemon.rarity || 'Comum',
    mult: Number(pokemon.mult) || 1,
    shiny: !!pokemon.shiny,
    pokemon,
  };
}
